import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../../firebase";
import AdminHorariosAtencion from "./AdminHorariosAtencion";
import {
  crearHorariosVacios,
  normalizarHorariosAtencion,
  validarHorariosAtencion,
} from "../../utils/horariosAtencion";

function AdminConfiguracion() {
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [nombreNegocio, setNombreNegocio] = useState("");
  const [telefonoNegocio, setTelefonoNegocio] = useState("");
  const [direccionNegocio, setDireccionNegocio] = useState("");
  const [latNegocio, setLatNegocio] = useState("");
  const [lngNegocio, setLngNegocio] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoArchivo, setLogoArchivo] = useState(null);
  const [logoAnchoPx, setLogoAnchoPx] = useState("160");
  const [logoAltoMaxPx, setLogoAltoMaxPx] = useState("100");

  const [radioEntregaKm, setRadioEntregaKm] = useState("8");
  const [costoEnvioBase, setCostoEnvioBase] = useState("0");
  const [costoEnvioPorKm, setCostoEnvioPorKm] = useState("0");

  const [horariosAtencion, setHorariosAtencion] = useState(crearHorariosVacios);

  const cargarConfiguracion = async () => {
    setCargando(true);
    setMensaje("");

    try {
      const configRef = doc(db, "configuracion", "negocio");
      const configSnap = await getDoc(configRef);

      if (configSnap.exists()) {
        const data = configSnap.data();

        setNombreNegocio(data.nombreNegocio || "");
        setTelefonoNegocio(data.telefonoNegocio || "");
        setDireccionNegocio(data.direccionNegocio || "");

        setLatNegocio(
          data.latNegocio !== undefined && data.latNegocio !== null
            ? String(data.latNegocio)
            : "",
        );

        setLngNegocio(
          data.lngNegocio !== undefined && data.lngNegocio !== null
            ? String(data.lngNegocio)
            : "",
        );

        setLogoUrl(data.logoUrl || "");

        setLogoAnchoPx(
          data.logoAnchoPx !== undefined && data.logoAnchoPx !== null
            ? String(data.logoAnchoPx)
            : "160",
        );

        setLogoAltoMaxPx(
          data.logoAltoMaxPx !== undefined && data.logoAltoMaxPx !== null
            ? String(data.logoAltoMaxPx)
            : "100",
        );

        setRadioEntregaKm(
          data.radioEntregaKm !== undefined && data.radioEntregaKm !== null
            ? String(data.radioEntregaKm)
            : "8",
        );

        setCostoEnvioBase(
          data.costoEnvioBase !== undefined && data.costoEnvioBase !== null
            ? String(data.costoEnvioBase)
            : "0",
        );

        setCostoEnvioPorKm(
          data.costoEnvioPorKm !== undefined && data.costoEnvioPorKm !== null
            ? String(data.costoEnvioPorKm)
            : "0",
        );

        setHorariosAtencion(normalizarHorariosAtencion(data.horariosAtencion));
      }
    } catch (error) {
      console.error("Error cargando configuración:", error);
      setMensaje("❌ No se pudo cargar la configuración del negocio.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  const handleGuardarConfiguracion = async (e) => {
    e.preventDefault();

    if (!nombreNegocio.trim()) {
      setMensaje("⚠️ Ingresa el nombre del negocio.");
      return;
    }

    if (!direccionNegocio.trim()) {
      setMensaje("⚠️ Ingresa el domicilio del negocio.");
      return;
    }

    if (!latNegocio || !lngNegocio) {
      setMensaje("⚠️ Ingresa latitud y longitud del negocio.");
      return;
    }

    const latNumero = Number(latNegocio);
    const lngNumero = Number(lngNegocio);

    if (Number.isNaN(latNumero) || Number.isNaN(lngNumero)) {
      setMensaje("⚠️ Latitud y longitud deben ser números válidos.");
      return;
    }

    const validacionHorarios = validarHorariosAtencion(horariosAtencion);

    if (!validacionHorarios.valido) {
      setMensaje(`⚠️ ${validacionHorarios.errores[0]}`);
      return;
    }

    setGuardando(true);
    setMensaje("");

    try {
      let logoFinal = logoUrl;

      if (logoArchivo) {
        const nombreArchivo = `${Date.now()}_${logoArchivo.name}`;
        const logoRef = ref(storage, `configuracion/logo/${nombreArchivo}`);

        await uploadBytes(logoRef, logoArchivo);

        logoFinal = await getDownloadURL(logoRef);
      }

      const configRef = doc(db, "configuracion", "negocio");

      await setDoc(
        configRef,
        {
          nombreNegocio: nombreNegocio.trim(),
          telefonoNegocio: telefonoNegocio.trim(),
          direccionNegocio: direccionNegocio.trim(),
          latNegocio: latNumero,
          lngNegocio: lngNumero,
          logoUrl: logoFinal,
          logoAnchoPx: Number(logoAnchoPx || 160),
          logoAltoMaxPx: Number(logoAltoMaxPx || 100),
          radioEntregaKm: Number(radioEntregaKm || 0),
          costoEnvioBase: Number(costoEnvioBase || 0),
          costoEnvioPorKm: Number(costoEnvioPorKm || 0),
          horariosAtencion,
          actualizadoEn: serverTimestamp(),
        },
        { merge: true },
      );

      setLogoUrl(logoFinal);
      setLogoArchivo(null);

      const inputLogo = document.getElementById("input-logo-negocio");
      if (inputLogo) inputLogo.value = "";

      setMensaje("✅ Configuración del negocio guardada correctamente.");
    } catch (error) {
      console.error("Error guardando configuración:", error);
      setMensaje("❌ No se pudo guardar la configuración del negocio.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #eee",
          borderRadius: "16px",
          padding: "20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        }}
      >
        <h2
          style={{
            margin: "0 0 8px 0",
            fontSize: "22px",
            fontWeight: "900",
          }}
        >
          ⚙️ Configuración del negocio
        </h2>

        <p
          style={{
            margin: "0 0 18px 0",
            fontSize: "14px",
            color: "#666",
            lineHeight: "1.5",
          }}
        >
          Estos datos sirven para personalizar la tienda, calcular envíos,
          mostrar el logo y controlar horarios de recepción de pedidos.
        </p>

        {mensaje && (
          <div
            style={{
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "16px",
              fontSize: "14px",
              fontWeight: "700",
              backgroundColor: mensaje.startsWith("✅") ? "#e6f4ea" : "#fce8e6",
              color: mensaje.startsWith("✅") ? "#137333" : "#c5221f",
            }}
          >
            {mensaje}
          </div>
        )}

        {cargando ? (
          <p style={{ fontWeight: "700" }}>Cargando configuración...</p>
        ) : (
          <form
            onSubmit={handleGuardarConfiguracion}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "14px",
            }}
          >
            <div>
              <label style={labelStyle}>Nombre del negocio</label>
              <input
                type="text"
                value={nombreNegocio}
                onChange={(e) => setNombreNegocio(e.target.value)}
                placeholder="Mítico Amorcito"
                style={inputStyle}
              />
            </div>

            <div>
              <label style={labelStyle}>Teléfono del negocio</label>
              <input
                type="text"
                value={telefonoNegocio}
                onChange={(e) => setTelefonoNegocio(e.target.value)}
                placeholder="3312345678"
                style={inputStyle}
              />
            </div>

            <div>
              <label style={labelStyle}>Domicilio base del negocio</label>
              <textarea
                value={direccionNegocio}
                onChange={(e) => setDireccionNegocio(e.target.value)}
                placeholder="Calle, número, colonia, ciudad..."
                rows={3}
                style={{
                  ...inputStyle,
                  resize: "vertical",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
              }}
            >
              <div>
                <label style={labelStyle}>Latitud</label>
                <input
                  type="number"
                  step="any"
                  value={latNegocio}
                  onChange={(e) => setLatNegocio(e.target.value)}
                  placeholder="20.6736"
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Longitud</label>
                <input
                  type="number"
                  step="any"
                  value={lngNegocio}
                  onChange={(e) => setLngNegocio(e.target.value)}
                  placeholder="-103.344"
                  style={inputStyle}
                />
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "10px",
              }}
            >
              <div>
                <label style={labelStyle}>Radio entrega km</label>
                <input
                  type="number"
                  step="any"
                  value={radioEntregaKm}
                  onChange={(e) => setRadioEntregaKm(e.target.value)}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Costo base envío</label>
                <input
                  type="number"
                  step="any"
                  value={costoEnvioBase}
                  onChange={(e) => setCostoEnvioBase(e.target.value)}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Costo por km</label>
                <input
                  type="number"
                  step="any"
                  value={costoEnvioPorKm}
                  onChange={(e) => setCostoEnvioPorKm(e.target.value)}
                  style={inputStyle}
                />
              </div>
            </div>

            <AdminHorariosAtencion
              horariosAtencion={horariosAtencion}
              setHorariosAtencion={setHorariosAtencion}
            />

            <div>
              <label style={labelStyle}>Logo del restaurante</label>

              {logoUrl && (
                <div
                  style={{
                    marginBottom: "10px",
                    backgroundColor: "#f8f8f8",
                    borderRadius: "12px",
                    padding: "12px",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={logoUrl}
                    alt="Logo del negocio"
                    style={{
                      width: `${Number(logoAnchoPx || 160)}px`,
                      maxHeight: `${Number(logoAltoMaxPx || 100)}px`,
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}

              <input
                id="input-logo-negocio"
                type="file"
                accept="image/*"
                onChange={(e) => setLogoArchivo(e.target.files[0] || null)}
                style={inputStyle}
              />

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <div>
                  <label style={labelStyle}>Ancho del logo px</label>
                  <input
                    type="number"
                    value={logoAnchoPx}
                    onChange={(e) => setLogoAnchoPx(e.target.value)}
                    placeholder="160"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Alto máximo px</label>
                  <input
                    type="number"
                    value={logoAltoMaxPx}
                    onChange={(e) => setLogoAltoMaxPx(e.target.value)}
                    placeholder="100"
                    style={inputStyle}
                  />
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={guardando}
              style={{
                backgroundColor: guardando ? "#777" : "#111",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                padding: "14px",
                fontSize: "15px",
                fontWeight: "900",
                cursor: guardando ? "not-allowed" : "pointer",
              }}
            >
              {guardando ? "Guardando..." : "Guardar configuración"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "800",
  marginBottom: "5px",
  color: "#333",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default AdminConfiguracion;
